<template>
  <b-row
    :class="pageHeaderClasses"
  >
    <b-col
      cols="6"
      md="6"
      offset="3"
      offset-md="3"
    >
      <img
        src="../assets/BETS-e-white.png"
        class="logo"
        v-if="loggedIn"
      >
    </b-col>

    <b-col
      cols="3"
      md="3"
      class="d-flex flex-column justify-content-center"
    >
      <b-row>
        <b-col
          cols="6"
          class="p-0"
        >
          <div
            class="text-right text-white"
            v-if="isSelfMode"
          >
            Self Screen
          </div>
        </b-col>
        <b-col
          cols="6"
          class="text-left"
        >
          <a
            v-show="(isSelfSignInLogin || isBfmLogin) && !loggedIn"
            href="#"
            @click="backToLoginSelect"
            class="logout"
            style="width: 25px;"
          >
            <img
              src="../assets/log-out-icon-gray.png"
              class="logout-icon"
            >
          </a>
          <a
            v-if="isOnline"
            href=""
            @click="logout"
            class="logout"
            style="width: 25px;"
          >
            <img
              src="../assets/log-out-icon-gray.png"
              class="logout-icon"
              v-if="loggedIn"
            >
          </a>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PageHeader',
  computed: {
    ...mapGetters([
      'pageAlertInformation'
    ]),
    ...mapGetters({
      viewingQuestionnaire: 'forms/viewingQuestionnaire'
    }),
    pageHeaderClasses () {
      const classes = []
      classes.push('page-header')
      if (!this.viewingQuestionnaire && this.pageAlertInformation.message.length === 0) {
        classes.push('page-header-margin-bottom')
      }
      return classes
    }
  },
  methods: {
    ...mapActions({
      logout: 'authentication/logout',
      backToLoginSelect: 'backToLoginSelect'
    })
  }
}
</script>

<style scoped lang="scss">
.page-header {
  background-color: #125E52;
  padding-bottom: 1rem;
  padding-top: 1rem;
  text-align: center;
  min-height: 70px;

  .logo {
    height: 40px;
  }
}

.page-header-margin-bottom {
  margin-bottom: 3rem;
  transition: all 0.5s ease-in-out;
}

.logout {
  text-align: right;

  .logout-icon {
    width: 25px;
  }
}
</style>
